import { MediaUri } from "../../constants/enum";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import { GrCloudUpload } from "react-icons/gr";

function Carousel({ data }: any) {
  const mainImageObjects = data.map((img: any) => ({
    original: `${MediaUri}/display/${img.path}`,
    thumbnail: `${MediaUri}/thumbnail/${img.path}`,
    renderItem: () => {
      return (
        <a href={`/product/${img.productLibProductFilesId}/show`}>
          <div className="w-full h-[30rem] flex flex-row justify-center">
            <img
              className="object-contain "
              src={`${MediaUri}/display/${img.path}`}
              alt={`${img.name}`}
              onError={(e: any) => {
                e.target.src = "/brands/no_image.png";
              }}
            />
          </div>
        </a>
      );
    },
  }));

  return (
    <div className="p-4">
      <div className="flex flex-row justify-center my-4">
        <div className="flex flex-row w-full gap-4 lg:w-3/4">
          <GrCloudUpload size={35} />
          <span className="text-lg text-gray-600 lg:text-2xl">
            Recently updated products
          </span>
        </div>
      </div>
      <div className="flex flex-row justify-center">
        <div className="w-full lg:w-3/4">
          <ImageGallery
            items={mainImageObjects.reverse()}
            infinite={true}
            autoPlay={true}
            showBullets={false}
            showFullscreenButton={false}
            showPlayButton={false}
            showThumbnails={true}
            onErrorImageURL="/brands/no_image.png"
          />
        </div>
      </div>
    </div>
  );
}
export default Carousel;
